// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__13MoQ","left":"InfoRow_left__1v1ub"};